import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import alignStyles from './style/align.css';
import generalStyles from './style/general.css';
import sizeStyles from './style/size.css';
import sizeSStyles from './style/sizeS.css';
import sizeMStyles from './style/sizeM.css';
import sizeLStyles from './style/sizeL.css';

const cx = classNames.bind({
  ...alignStyles,
  ...generalStyles,
});

/**
 * A very simple grid implementation which relies on the CSS
 * `display: inline-block` property. The optional `size` prop is available as
 * well as vertical alignment with the `align` prop.
 */
export default function InlineGrid({
  align,
  children,
  size,
  sizeL,
  sizeM,
  sizeS,
}) {
  const wrappedChildren = Children.map(children, (child, index) => {
    if (!child) {
      return null;
    }

    const lastChild = children.length - 1 === index;
    const className = cx([align], {
      [sizeStyles[size]]: !lastChild,
      [sizeSStyles[sizeS]]: !lastChild && sizeS,
      [sizeMStyles[sizeM]]: !lastChild && sizeM,
      [sizeLStyles[sizeL]]: !lastChild && sizeL,
    });
    return (
      <div key={index} className={className}>
        {child}
      </div>
    );
  });

  const containerClasses = cx('container');

  return <div className={containerClasses}>{wrappedChildren}</div>;
}

InlineGrid.propTypes = {
  align: PropTypes.oneOf(Object.keys(alignStyles)),
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf([...Object.keys(sizeStyles), 'none']),
  sizeS: PropTypes.oneOf([...Object.keys(sizeStyles), 'none']),
  sizeM: PropTypes.oneOf([...Object.keys(sizeStyles), 'none']),
  sizeL: PropTypes.oneOf([...Object.keys(sizeStyles), 'none']),
};

InlineGrid.defaultProps = {
  align: 'middle',
  fontSize: 'm',
  size: 'm',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-grid/InlineGrid/index.js